import {RaporKosulEntity} from "@/entity/RaporKosulEntity";

export default class RaporKosulGrupEntity{
    ve_mi: boolean = true;
    kosullar!: Array<RaporKosulEntity>[];
}